RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const FbPostDetailsSocialEngagementView = widgets.PostDetailsColumnView.extend({
        columnWidth: 4
    });


    const FbPostDetailsSocialEngagementWidget = widgets.PostDetailsWidgetBase.extend({
        title: RivalIQ.strings.facebook_insights_post_detail_social_engagement_title,
        description: RivalIQ.strings.facebook_insights_post_detail_social_engagement_description,
        alert: function () {
            const me = this;
            const description = RivalIQ.strings.facebook_insights_post_detail_data_warning_description;
            return App.utils.getUnderReportingAlert(me.curation, description);
        },
        view: FbPostDetailsSocialEngagementView,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            const widgets = [
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PERCENTAGE,
                    title: RivalIQ.strings.facebook_insights_post_detail_social_engagement_social_engagement_rate_title,
                    barTitle: RivalIQ.strings.facebook_insights_post_detail_social_engagement_social_engagement_rate_bar_title,
                    hideBar: true,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_AND_SHARES_ENGAGEMENT_TOTAL', {
                        name: RivalIQ.strings.facebook_insights_post_detail_social_engagement_social_engagement_rate_title,
                        description: RivalIQ.strings.facebook_insights_post_detail_social_engagement_social_engagement_rate_description
                    }),
                    divisor: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACH')
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_AND_SHARES_ENGAGEMENT_TOTAL', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_AND_SHARES_REACTIONS',
                            'FACEBOOK_INSIGHTS_POST_AND_SHARES_COMMENTS',
                            'FACEBOOK_INSIGHTS_POST_AND_SHARES_SHARES'
                        ]
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_SHARES_ENGAGEMENT_TOTAL', {
                        displayString: RivalIQ.strings.facebook_insights_post_detail_social_engagement_social_engagement_display
                    })
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ENGAGEMENT_TOTAL', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_REACTIONS',
                            'FACEBOOK_INSIGHTS_POST_COMMENTS',
                            'FACEBOOK_INSIGHTS_POST_SHARES'
                        ]
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_PERCENT_OF_ENGAGEMENT', {
                        displayString: RivalIQ.strings.facebook_insights_post_detail_social_engagement_social_engagement_total_display
                    })
                }
            ];

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POST_SOCIAL_ENGAGEMENT, FbPostDetailsSocialEngagementWidget);

    const FbReelDetailsSocialEngagementView = widgets.PostDetailsColumnView.extend({
        columnWidth: 6
    });

    const FbReelDetailsSocialEngagementWidget = FbPostDetailsSocialEngagementWidget.extend({
        view: FbReelDetailsSocialEngagementView,
        description: RivalIQ.strings.facebook_insights_reel_detail_social_engagement_description,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            const widgets = [
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PERCENTAGE,
                    title: RivalIQ.strings.facebook_insights_post_detail_social_engagement_social_engagement_rate_title,
                    barTitle: RivalIQ.strings.facebook_insights_post_detail_social_engagement_social_engagement_rate_bar_title,
                    hideBar: true,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ENGAGEMENT_TOTAL', {
                        name: 'Social Engagement by Reach',
                        description: RivalIQ.strings.facebook_insights_post_engagement_rate_by_reach_description
                    }),
                    divisor: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACH')
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ENGAGEMENT_TOTAL', {
                        name: 'Social Engagement Total',
                        description: RivalIQ.strings.facebook_insights_post_engagement_total_description,
                        submetrics: [
                            {
                                semanticId: 'FACEBOOK_INSIGHTS_POST_REACTIONS',
                                name: 'Reactions',
                                description: RivalIQ.strings.facebook_insights_post_reactions_description
                            },
                            {
                                semanticId: 'FACEBOOK_INSIGHTS_POST_COMMENTS',
                                name: 'Comments',
                                description: RivalIQ.strings.facebook_insights_post_comments_description
                            },
                            {
                                semanticId: 'FACEBOOK_INSIGHTS_POST_SHARES',
                                name: 'Shares',
                                description: RivalIQ.strings.facebook_insights_post_shares_description
                            }
                        ]
                    })
                }
            ];

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_REEL_SOCIAL_ENGAGEMENT, FbReelDetailsSocialEngagementWidget);

});
